module.exports = __webpack_public_path__ + "static/media/bg-home.2a3b8bc3.mp4";